import { render } from "./editConfigDrawer1.vue?vue&type=template&id=44d5d6e8&scoped=true"
import script from "./editConfigDrawer1.vue?vue&type=script&setup=true&lang=js"
export * from "./editConfigDrawer1.vue?vue&type=script&setup=true&lang=js"

import "./editConfigDrawer1.vue?vue&type=style&index=0&id=44d5d6e8&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44d5d6e8"],['__file',"src/views/exhibitionManage/components/editConfigDrawer1.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "44d5d6e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44d5d6e8', __exports__)) {
    console.log('reload')
    api.reload('44d5d6e8', __exports__)
  }
  
  module.hot.accept("./editConfigDrawer1.vue?vue&type=template&id=44d5d6e8&scoped=true", () => {
    console.log('re-render')
    api.rerender('44d5d6e8', render)
  })

}


export default __exports__